import { apiClient } from './client';
import { Tag, PaginatedResponse } from '../../types';

export interface CreateTagRequest {
  name: string;
  description?: string;
  status?: 'active' | 'inactive';
}

export interface UpdateTagRequest extends Partial<CreateTagRequest> {}

export interface GetTagsParams {
  pageIndex?: number;
  pageSize?: number;
  name?: string;
  status?: 'active' | 'inactive';
}

export const tagsApi = {
  getTags: async (params?: GetTagsParams): Promise<PaginatedResponse<Tag>> => {
    return apiClient.get<PaginatedResponse<Tag>>('/api/v1/admin/tags', { params });
  },

  getTagDetail: async (id: string): Promise<{ data: Tag }> => {
    return apiClient.get<{ data: Tag }>(`/api/v1/admin/tags/${id}`);
  },

  createTag: async (data: CreateTagRequest): Promise<{ data: Tag }> => {
    return apiClient.post<{ data: Tag }>('/api/v1/admin/tags', data);
  },

  updateTag: async (id: string, data: UpdateTagRequest): Promise<{ data: Tag }> => {
    return apiClient.put<{ data: Tag }>(`/api/v1/admin/tags/${id}`, data);
  },

  deleteTag: async (id: string): Promise<{ data: {} }> => {
    return apiClient.delete<{ data: {} }>(`/api/v1/admin/tags/${id}`);
  },
};


